module.exports = __webpack_public_path__ + "img/post-thumb-3.112c284c.jpg";